import { render, staticRenderFns } from "./RoHFooter.vue?vue&type=template&id=53a3367f&scoped=true&"
import script from "./RoHFooter.vue?vue&type=script&lang=js&"
export * from "./RoHFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3367f",
  null
  
)

export default component.exports